import { FC } from 'react';
import { Button, Tooltip } from '@mui/material';
import { openCreateApiKeyModal } from '../store-actions/create-api-key-store-actions';

const CreteApiKeyButton: FC<
  React.PropsWithChildren<CreteApiKeyButtonProps>
> = ({ isUserAdminRole }) => {
  const tooltipTitle = isUserAdminRole
    ? 'Create API Key to be used for OX services'
    : 'Your user role prevents you from performing this action';
  return (
    <Tooltip arrow title={tooltipTitle}>
      <div>
        <Button
          variant='contained'
          color='primary'
          aria-label='close'
          onClick={() => openCreateApiKeyModal()}
          disabled={!isUserAdminRole}>
          Create API Key
        </Button>
      </div>
    </Tooltip>
  );
};

export interface CreteApiKeyButtonProps {
  isUserAdminRole: boolean;
}

export default CreteApiKeyButton;
